import { restoreProjectDefinition } from "@snubes/snubes-types";
import { getCallable } from "../../Firebase/helpers/getCallable";

export const restoreProjectCallable = getCallable(restoreProjectDefinition);
